import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { AreaChart, BarChart, RatingIndicator } from '../../../shared';
import { getDifferenceBetweenDateRange } from '../../../../utility';

const Engagement = (props) => {
    const {
        chartType,
        title,
        chartOptions,
        chartSeries,
        handleClick,
        engagementSummary,
        engagementId,
        selectedId 
    } = props;
    
    const { startDateRange, endDateRange } = useSelector((state) => state.filter);
    const renderChart = (chartTypes) => {
        const chartComponents = {
            bar: <BarChart chartOptions={chartOptions} chartSeries={chartSeries} />,
            area: <AreaChart chartOptions={chartOptions} chartSeries={chartSeries} />
        };
        return chartComponents[chartTypes] || null;
    };

    const current = engagementSummary.currentEngagement;
    const previous = engagementSummary.previousEngagement;
    const change = previous === 0 && current === 0 ? 0 : (current - previous) * 100 / previous;
    return (
        <Box 
            className={`padding-t-24-b-0-rl-24 cursor-pointer
                ${(engagementId === selectedId && change > 0 && selectedId === 0) ? 'IncreaseEngagement' : 
            (engagementId === selectedId && change < 0 && selectedId === 0) ? 'decreaseEngagement' :
                (engagementId === selectedId && change > 0 && selectedId === 1) ? 'IncreaseDigitalEngagement' :
                    (engagementId === selectedId && change < 0 && selectedId === 1) ? 'decreaseDigitalEngagement' :
                        (engagementId === selectedId && change > 0 && selectedId === 2) ? 'IncreaseFieldEngagement' :
                            (engagementId === selectedId && change < 0 && selectedId === 2) ? 'decreaseFieldEngagement' :
                                (engagementId === selectedId && current === previous && selectedId === 0) ? 'noChangeTopEngagement' :
                                    (engagementId === selectedId && current === previous && selectedId === 1) ? 'noChangeDigitalEngagement' :
                                        (engagementId === selectedId && current === previous && selectedId === 2) ? 'noChangeFieldEngagement' : ''
        }`}
            onClick={handleClick}
        >
            <Typography className="text-xs-semi-bold gray-900 mb-8px icon">
                {title}
            </Typography>
            <Box className="flex-row-space-between">
                <Box>
                    <Typography className="display-xs-semi-bold gray-900">
                        {engagementSummary.currentEngagement}
                    </Typography>
                </Box>
                <Box>
                    <RatingIndicator 
                        current={engagementSummary.currentEngagement} 
                        previous={engagementSummary.previousEngagement}
                    />
                    <Typography className="text-xs-regular gray-500">
                        vs Last {getDifferenceBetweenDateRange(startDateRange, endDateRange)}
                    </Typography>
                </Box>
            </Box>
            <Box>{renderChart(chartType)}</Box>
        </Box>
    );
};

// Add PropTypes validation
Engagement.propTypes = {
    chartType: PropTypes.oneOf(['bar', 'area']).isRequired,
    title: PropTypes.string.isRequired,
    chartOptions: PropTypes.object.isRequired,
    chartSeries: PropTypes.array.isRequired,
    handleClick: PropTypes.func,
    engagementSummary: PropTypes.shape({
        currentEngagement: PropTypes.number.isRequired,
        previousEngagement: PropTypes.number.isRequired
    }).isRequired,
    engagementId: PropTypes.number.isRequired,
    selectedId: PropTypes.number.isRequired
};

export default Engagement;
